import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { HelpSupportTicketsEffects, helpSupportTicketsFeature } from './store';

export function provideHelpSupportTicketsFeature(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(helpSupportTicketsFeature),
    provideEffects(HelpSupportTicketsEffects),
  ]);
}
